import { render, staticRenderFns } from "./StaffMembers.vue?vue&type=template&id=133a6e49&"
import script from "./StaffMembers.vue?vue&type=script&lang=js&"
export * from "./StaffMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports